import { notification } from "antd";

import { BellOutlined } from "@ant-design/icons";
import { IconType } from "antd/lib/notification";
import React, { useContext, useState } from "react";
import { useCreateSearchAlert } from "./hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { LoadingIcon } from "shared-components/Components/CustomIcons/LoadingIcon/LoadingIcon";

export const CreateSearchAlert = () => {
	const { searchAlert, alertIsSaved, loading } = useCreateSearchAlert();
	const { country_code } = useContext(ConfigStateContext);
	const [load, setLoad] = useState(false);

	const changeAlert = isSaveAlert => {
		setLoad(true)
		setTimeout(() => {
			setLoad(false)
		}, 5000);
		searchAlert.send(0).then(data => {
			if (!data) {
				return;
			}

			let message = "Búsqueda eliminada";
			let description = "Ya no recibira alertas cuando se actualicen los resultados de la búsqueda";
			let type: IconType = "info";
			if (!isSaveAlert) {

				message = "Búsqueda Guardada";
				description = "Su búsqueda ha sido guardada exitosamente. Le enviaremos alertas cuando se actualicen en los resultados de su búsqueda";
				type = "success";
			}
			notification.open({
				type: type,
				message,
				description,
			});
		})
	};

	let text = "Guardar Búsqueda";
	if (searchAlert && searchAlert.response.loading && load) text = "Guardando";
	else if (alertIsSaved) text = "Búsqueda Guardada";

	return (
		<button
			disabled={loading}
			className={"btn-third " + country_code}
			onClick={() => changeAlert(alertIsSaved)}
		>
			{load ?
				<LoadingIcon classes="loading-icon" /> :
				<BellOutlined />
			}
			<span>{text}</span>
		</button>
	);
};
